import request, { post, get } from '@/utils/request'
import { ouchnCustom } from '../../service'


//我的课程列表
export const GetCourseList = (params) => {
    return request({
      url: ouchnCustom +'/web/api/myCourse/list',
      method: 'GET',
      params,
    })
}

//获取课堂活动列表  
export const GetActiveList = (params) => {
    return request({
      url: ouchnCustom +'/web/api/myCourse/activtyList',
      method: 'GET',
      params,
    })
}

//获取学员列表 
export const GetStudentList = (params) => {
    return request({
      url: ouchnCustom +'/web/api/myCourse/studentList',
      method: 'GET',
      params,
    })
}

//获取统计列表
export const GetStatistics = (params) => {
    return request({
      url: ouchnCustom +'/web/api/myCourse/selectStatistics',
      method: 'GET',
      params,
    })
}

//获取阅读统计
export const GetReadStatistics = (params) => {
    return request({
      url: ouchnCustom +'/web/api/myCourse/readingStatistics',
      method: 'GET',
      params,
    })
}

//讨论详情
export const getDiscussInfoApi = (params) => {
  return request({
    url: ouchnCustom +'/device/api/Discuss/getDiscussInfo',
    method: 'GET',
    params,
  })
}

//查询讨论详情
export const addDiscussReplyApi = (data) => {
  return request({
    url: ouchnCustom +'/device/api/Discuss/addDiscussReply',
    method: 'POST',
    data,
  })
}
//回复
export const getDiscussDiscussReplyListApi = (params) => {
  return request({
    url: ouchnCustom +'/device/api/Discuss/getDiscussDiscussReplyList',
    method: 'GET',
    params,
  })
}